<template>
  <div class="">
    <div class="bg-gray-50 rounded-xl p-3 ">
      <div class="flex-col -mt-4 flex gap-6 ">
        <div class="flex flex-col">
          <div v-for="(userProperty, index) in userProperties" class=" flex flex-col gap-6 mt-4">
            <div v-if="userProperty.final_outcome_result"
              class=" rounded-xl border border-gray-200 bg-white overflow-hidden ">


              <!-- Property address -->
              <div class=" mx-4 sm:mx-6 mt-4 ">
                <p class="font-bold text-gray-900 text-sm sm:text-lg">
                  {{ userProperty.Situs_Address }}
                  <span class="font-normal text-gray-400">(#{{ userProperty.account_no }})</span>
                </p>
              </div>

              <!-- Reduction summary banner -->
              <div v-if="userProperty.final_outcome_result.amount_of_reduction > 0"
                class=" mx-4 sm:mx-6 mt-4 rounded-lg p-4 flex items-start gap-3"
                style="background-color: #F1F8F1; border: 1px solid #E3EEE4;">

                <div class="flex-shrink-0 h-8 w-8 flex items-center justify-center">
                  <img src="/images/Frame%201116606612.svg" alt="Reduced" class="h-8 w-8">
                </div>
                <div>
                  <p class="font-bold text-base sm:text-lg" style="color: #038A14;">
                    We reduced your property value by {{ userProperty.final_outcome_result.amount_of_reduction |
                      toCurrency }}.
                  </p>
                  <p class="text-gray-700 text-sm mt-0.5" v-if="reductionPercentage(userProperty)">
                    That's a <span class="font-bold">{{ reductionPercentage(userProperty) }}%</span> reduction in your
                    appraised market value.
                  </p>
                </div>
              </div>

              <!-- Reduction summary banner -->
              <div v-if="userProperty.final_outcome_result.amount_of_reduction == 0"
                class=" mx-4 sm:mx-6 mt-4 rounded-lg p-4 flex items-start gap-3"
                style="background-color: #F1F8F1; border: 1px solid #E3EEE4;">

                <!--  -->
                <div>
                  <p class="font-bold text-base sm:text-lg" style="color: #000000;">
                    Your 2026 property tax protest is complete
                  </p>

                </div>
              </div>

              <!-- Properties Card Table - Amount Reduction details -->
              <div class="px-4 sm:px-6 pb-4 pt-3">
                <table class="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden">
                  <tbody class="divide-y divide-gray-200">
                    <!-- <tr v-if="userProperty.final_outcome_result.tad_evidence_support_this_value"
                        class="divide-x divide-gray-200">
                        <th class="py-3 text-left pl-4 pr-3 text-sm font-medium text-gray-700 sm:pl-6">CAD's
                          Evidence Supports This Value</th>

                        <td class=" px-3 w-32 py-3 text-sm text-right text-gray-700">
                          <p>{{ userProperty.final_outcome_result.tad_evidence_support_this_value | toCurrency }}</p>
                        </td>
                      </tr> -->
                    <tr class="divide-x divide-gray-200">
                      <th class="text-left py-3 pl-4 pr-3 text-sm font-medium text-gray-700 sm:pl-6">{{ countyName }}'s
                        Proposed Market Value <span class="font-normal text-gray-400">(prior to protest)</span></th>

                      <td class="whitespace-nowrap px-3 py-3 w-32 text-sm text-gray-700 text-right">
                        <p>
                          {{ userProperty.final_outcome_result.tad_proposed_market_value | toCurrency }}</p>
                      </td>
                    </tr>
                    <tr class="divide-x divide-gray-200">
                      <th class=" py-3 text-left pl-4 pr-3 text-sm font-medium sm:pl-6" style="color: #038A14;">
                        Your Value Reduction
                      </th>

                      <td class=" text-right whitespace-nowrap px-3 w-32 py-3 text-sm font-medium"
                        style="color: #038A14;">
                        <p>
                          −{{ userProperty.final_outcome_result.amount_of_reduction | toCurrency }}</p>

                      </td>
                    </tr>
                    <tr class="divide-x divide-gray-200">
                      <th class="text-left py-3 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6">Final
                        Market Value After Protest</th>

                      <td class="whitespace-nowrap px-3 py-3 w-32 text-sm text-right font-bold text-gray-900">
                        <p>
                          {{ userProperty.final_outcome_result.final_market_value | toCurrency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Summary Section - Cost of Service -->
      
      <div v-if="serviceCost > 0" class="p-3 text-sm">

        <!-- Estimated Tax Savings -->
        <div class="flex justify-between items-center font-semibold text-blue-600">
          <span class="flex items-center gap-1">
            <span>Your estimated tax savings</span>

            <span class="help-tooltip-wrapper relative inline-flex items-center" @mouseenter="showHelp('savings')"
              @mouseleave="hideHelp('savings')" @click.stop="toggleHelp('savings')">
              <svg class="h-3.5 w-3.5 cursor-pointer" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" aria-label="Help for estimated tax savings">
                <circle cx="12" cy="12" r="9.25" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 11v5.5" />
                <circle cx="12" cy="8" r="0.75" fill="currentColor" stroke="none" />
              </svg>

              <div v-if="activeHelp === 'savings'"
                class="help-tooltip-box absolute z-50 bottom-6 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-900 rounded text-white font-normal"
                @click.stop @mouseenter="activeHelp = 'savings'">
                <p class="text-xs text-left leading-5">
                  Actual tax savings may vary based on exemptions, tax ceilings, capped value, and final tax rates.
                </p>

                <!-- Arrow -->
                <span class="absolute -bottom-1 h-2 w-2 bg-gray-900 pointer-events-none"
                  style="left: 50%; transform: translateX(-50%) rotate(45deg);"></span>
              </div>
            </span>
          </span>

          <span>${{ totalEstimatedTaxSaved }}</span>
        </div>

        <!-- Estimated Fee -->
        <div class="flex justify-between items-center text-gray-600 mt-1">
          <span class="flex items-center gap-1">
            <span>Estimated fee at other firms</span>

            <span class="help-tooltip-wrapper relative inline-flex items-center" @mouseenter="showHelp('fee')"
              @mouseleave="hideHelp('fee')" @click.stop="toggleHelp('fee')">
              <svg class="h-3.5 w-3.5 cursor-pointer" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" aria-label="Help for estimated fee">
                <circle cx="12" cy="12" r="9.25" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 11v5.5" />
                <circle cx="12" cy="8" r="0.75" fill="currentColor" stroke="none" />
              </svg>

              <div v-if="activeHelp === 'fee'"
                class="help-tooltip-box absolute z-50 bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-900 rounded text-white font-normal"
                @click.stop @mouseenter="activeHelp = 'fee'">
                <p class="text-xs text-left leading-5">
                  Some firms charge up to 50% of tax savings. Others charge a
                  $300–$500 flat fee per property, even without savings. This amount
                  estimates what comparable service could cost elsewhere.
                </p>

                <!-- Arrow -->
                <span class="absolute -bottom-1 h-2 w-2 bg-gray-900 pointer-events-none"
                  style="left: 50%; transform: translateX(-50%) rotate(45deg);"></span>
              </div>
            </span>
          </span>

          <span class="line-through">
            {{ serviceCost | toCurrency }}
          </span>
        </div>

      </div>
    </div>

    <!-- Chandler Video Card -->
    <div class="mt-6 mx-0">

      <div class="rounded-xl border border-gray-200 bg-white overflow-hidden">
        <div class="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 p-3 sm:p-4">

          <!-- Video Thumbnail -->
          <div
            class="relative flex-shrink-0 w-full sm:w-44 md:w-48 h-28 sm:h-28 md:h-32 rounded-lg overflow-hidden cursor-pointer group"
            @click="playChandlerVideo">
            <img src="/assets/images/final_result_step1_video_thumbnail.png" alt="A quick note from Chandler"
              class="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105" />

            <!-- Dark overlay -->
            <div class="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-20 transition-all duration-200">
            </div>

            <!-- Play button -->
            <div class="absolute inset-0 flex items-center justify-center">
              <div
                class="w-12 h-12 sm:w-11 sm:h-11 rounded-full bg-black bg-opacity-45 border-2 border-white flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-200">
                <svg class="w-6 h-6 text-white ml-1" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Text -->
          <div class="flex-1 text-center sm:text-left">
            <h3 class="text-lg font-bold text-indigo-700 mb-1">
              A quick note from Chandler
            </h3>

            <p class="text-sm text-gray-700 leading-6">
              {{ reductionDetails.video_description }}
            </p>
            
          </div>

        </div>
      </div>
    </div>


    <!-- Pay What You Want -->
    <div class="rounded-xl mt-6 bg-indigo-50 border border-indigo-100 ">

      <!-- Required Fee Card -->

      <div class="flex flex-col items-center gap-4 px-4 sm:px-8 pt-8 pb-4">

        <!-- Fee -->
        <div class="flex-shrink-0 text-center">
          <h3 class="text-xl font-bold text-indigo-700 whitespace-nowrap">
            Your Required Fee: $0
          </h3>
        </div>

        <!-- Description -->
        <div class="flex-1 text-center">
          <p class="leading-6 text-center text-gray-700 text-sm">
            We offer this service with a $0 required fee because we believe every homeowner should have access to
            professional property tax representation, regardless of their ability to pay. If this service was valuable
            to you and you're able to chip in, any contribution helps cover our cost and pays it forward so we can keep
            the required fee at $0 for the next homeowner.
          </p>
        </div>

      </div>


      <div class="relative my-6">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300 border-dashed"></div>
        </div>
      </div>

      <div class="px-4 sm:px-8 py-8 flex flex-col items-center gap-3 text-center">
        <p class="text-indigo-700 text-xl sm:text-2xl font-extrabold">Pay What You Want</p>
        <div>
          <p>Choose the amount you'd like to pay.</p>
        </div>

        <div class="w-full max-w-lg">
          <div class="bg-white flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 overflow-hidden">
            <div class="flex w-full items-center">
              <span class="pl-4 text-gray-500 text-lg font-semibold select-none">$</span>
              <input type="number" ref="amount1" @focus="selectAmount('amount1')" v-model="amount" id="amount"
                name="amount" min="0" required
                class="block w-full border-0 bg-transparent py-3 pl-1 pr-4 text-gray-900 text-center text-lg font-semibold placeholder:text-gray-400 focus:ring-0"
                :placeholder="placeholderText">
            </div>
          </div>
        </div>

        <div class="gap-2 grid grid-cols-2 items-center justify-center max-w-lg mt-2 sm:grid-cols-4 w-full"
          v-if="isIncludeQuickOption && quickOptionsButton && (quickOptionsButton.suggestion1 || quickOptionsButton.suggestion2 || quickOptionsButton.suggestion3)">
          <button
            v-for="(suggested, index) in [quickOptionsButton.suggestion1, quickOptionsButton.suggestion2, quickOptionsButton.suggestion3]"
            :key="suggested" @click="fillSuggestionAmount(suggested)" type="button" :class="[
              'px-5 py-2 text-sm font-semibold border rounded-md transition',
              isSelectedAmount(suggested) ? 'bg-indigo-600 border-indigo-600 text-white' : 'border-indigo-300 text-indigo-700 hover:bg-indigo-100'
            ]">
            ${{ suggested }}
          </button>
          <button type="button" @click="selectAmount('amount1')" :class="[
            'px-5 py-2 text-sm font-semibold border rounded-md transition',
            !isSuggestedAmount ? 'bg-indigo-600 border-indigo-600 text-white' : 'border-indigo-300 text-indigo-700 hover:bg-indigo-100'
          ]">
            Other
          </button>
        </div>

        <p class="italic text-gray-500 text-xs mt-2">
          To pay $0, enter 0 above
        </p>

        <button type="button" @click="goToDonate()"
          class="w-full max-w-lg mt-2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-3 bg-indigo-600 font-semibold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm">
          {{ donationButtonText }}
        </button>

        <p class="flex items-center gap-1.5 text-xs text-gray-500 mt-1">
          <i class="fa fa-lock"></i>
          Secure &amp; encrypted. Your information is safe.
        </p>
      </div>
    </div>



    <div class="relative my-6">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-gray-300 border-dashed"></div>
      </div>
    </div>

    <div class="pt-6">
      <div class="flex-col flex gap-3 mt-3 text-gray-500 text-sm font-normal subpixel-antialiased font-sans">

        <p class="">I am grateful for the opportunity to serve you!</p>
        <div class="flex flex-col gap-1">
          <div>
            <img class="inline-block" src="/assets/images/signature.png" style="height: 50px;">
          </div>
          <p class="text-gray-700 text-sm">Chandler Crouch</p>
        </div>
      </div>
    </div>

    <div>

      <!-- New -->

      <div class="mt-2">
        <div class="grid md:grid-cols-3 grid-cols-1 gap-6 sm:gap-8">

          <!-- Column 1 -->
          <div class="flex flex-col">
            <div class="flex flex-col items-center gap-2">
              <img class="object-cover w-full rounded h-img-height min-h-[180px]" src="/assets/images/Como_Workshop.jpg"
                alt="Me at seminar">
            </div>

            <!-- Description for Image 1 -->
            <div class="mt-3">
              <p class="font-bold text-gray-700 text-sm">
                45,000+ Free Protests with Over $50 Million in real cash Saved in 2026
              </p>

              <p class="mt-1 text-gray-700 text-sm">
                In 2026, filed 45,000+ property tax protests this year at no charge, saving homeowners more than $50
                million in actual cash while making professional tax protest representation accessible to everyone.
              </p>
            </div>
          </div>


          <!-- Column 2 -->
          <div class="flex flex-col">
            <div class="flex flex-col items-center gap-2">
              <img src="/assets/images/Me speaking at TAD board meeting.png" alt="Me speaking at TAD board meeting"
                class="object-content h-full w-full rounded object-cover object-top"
                style="max-height: 180px; min-height: 180px;" />
            </div>

            <!-- Description for Image 2 -->
            <div class="mt-3">
              <p class="font-bold text-gray-700 text-sm">
                Exposed a Value-Freeze Plan Hurting 190,000+ Homes
              </p>

              <p class="mt-1 text-gray-700 text-sm">
                Used appraisal data to show that 190,000+ homes would have received lower values without the board's
                "value freeze," then raised the alarm as the same flawed reappraisal approach was being advanced for
                statewide use.
              </p>
            </div>
          </div>


          <!-- Column 3 -->
          <div class="flex flex-col">
            <div class="flex flex-col items-center gap-2">
              <img class="object-cover w-full rounded h-img-height" src="/assets/images/Me and Abbott.jpg"
                alt="Me and Abbott">
            </div>

            <!-- Description for Image 3 -->
            <div class="mt-3">
              <p class="font-bold text-gray-700 text-sm">
                Advocating for Homeowners
              </p>

              <p class="mt-1 text-gray-700 text-sm">
                Making sure lawmakers and elected officials understand how property tax policy affects homeowners, and
                pushing for solutions that put homeowners first.
              </p>
            </div>
          </div>

        </div>
      </div>

      <div class=" mt-2  text-xs text-gray-500 pt-2 pb-4 border-t border-gray-100">
        Thank you for allowing me to serve you.
        – Chandler Crouch
      </div>
    </div>
    <ReductionVideoModal :visible="showVideoModal" :video-url="videoUrl" @close="showVideoModal = false" />
  </div>
</template>

<script>
import { apiUrl } from "../../../../config/base.js";
import ReductionVideoModal from "./ReductionVideoModal.vue";
export default {
  props: ['user-properties', 'total-estimated-tax-saved', 'service-cost', 'is-include-quick-option', 'quick-options-button', 'reduction-details'],
  data() {
    return {
      amount: null,
      countyName: 'Tarrant County',
      showVideoModal: false,
      videoUrl: null,
      activeHelp: null,
      lockedHelp: null,
    }
  },
  components: {
    ReductionVideoModal
  },
  created() {
    for (const userProperty of this.userProperties) {
      if (!userProperty.final_outcome_result) {
        userProperty.final_outcome_result = userProperty.historic_final_order_result
      }
    }
    this.prefilledAmount();
  },
  computed: {
    placeholderText() {

      if (this.amount == null || this.amount == '') {

        return 'Enter amount';

      }
    },
    isSuggestedAmount() {
      if (!this.isIncludeQuickOption || !this.quickOptionsButton) return false;
      const suggestions = [
        this.quickOptionsButton.suggestion1,
        this.quickOptionsButton.suggestion2,
        this.quickOptionsButton.suggestion3,
      ].map(Number);
      return suggestions.includes(Number(this.amount));
    },
    donationButtonText() {
      const amount = this.amount;

      if (amount == 0 || amount === null || amount === '') {
        return 'Finish';
      }

      return `Continue with $${amount}`;
    },

    showFiftyPercentFeeMessage() {
      const totalSaving = Number(this.totalEstimatedTaxSaved) || 0;
      const totalServiceCost = Number(this.serviceCost) || 0;

      const fiftyPercentFee = totalSaving / 2;
      const difference = Math.abs(totalServiceCost - fiftyPercentFee);

      return difference <= 1;
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    reductionPercentage(userProperty) {
      const result = userProperty.final_outcome_result;
      if (!result || !result.amount_of_reduction || !result.tad_proposed_market_value) return null;
      const percentage = (result.amount_of_reduction / result.tad_proposed_market_value) * 100;
      return Math.round(percentage * 10) / 10;
    },
    isSelectedAmount(suggested) {
      return Number(this.amount) === Number(suggested);
    },
    goToFeedback() {
      this.$emit('go-to-feedback-form', 'feedback_form');
    },
    goToDonate() {
      // If the user leaves the amount blank, treat it as a $0 donation instead of
      // blocking them.
      const amount = (this.amount === null || this.amount === '') ? 0 : this.amount;

      window.location.href = apiUrl + `/protest-requests/final-outcome/go-to-donation-page?amount=${amount}`;
      // window.location.href = apiUrl + `/protest-requests/final-outcome/show-donation-page?amount=${this.amount}`;
      //this.$emit('go-to-donate-page', 'donate_page');
    },

    prefilledAmount() {
      if (this.isIncludeQuickOption) {
        if (this.quickOptionsButton) {
          this.amount = this.quickOptionsButton.prefilled_amount ? this.quickOptionsButton.prefilled_amount : 0
        }
      }
    },

    fillSuggestionAmount(amount) {
      this.amount = amount;
    },
    selectAmount(refName) {
      // if(this.amount > 0) return;
      const input = this.$refs[refName];
      if (input && typeof input.select === 'function') {
        input.select();
      }
      // this.$refs.amount.select();

    },
    mouseOverPrefill(amount) {
      this.amount = amount;
    },
    playChandlerVideo() {
      if (!this.reductionDetails && !this.reductionDetails.video_url) {
        return;
      }

      this.videoUrl = this.reductionDetails.video_url;
      this.showVideoModal = true;
    },

    // new code
    showHelp(type) {
      this.activeHelp = type;
    },

    hideHelp(type) {
      // Don't close it if this tooltip was clicked/locked.
      if (this.lockedHelp === type) {
        return;
      }

      if (this.activeHelp === type) {
        this.activeHelp = null;
      }
    },

    toggleHelp(type) {
      if (this.lockedHelp === type) {
        // Second click → unlock and close
        this.lockedHelp = null;
        this.activeHelp = null;
        return;
      }

      // Click → open and lock
      this.activeHelp = type;
      this.lockedHelp = type;
    },

    closeHelp() {
      this.activeHelp = null;
      this.lockedHelp = null;
    },

    handleOutsideClick(event) {
      if (!event.target.closest('.help-tooltip-wrapper')) {
        this.closeHelp();
      }
    },

  }
}
</script>
